export enum LoadingStrategy {
  EAGER = 'eager',
  LAZY = 'lazy',
}

export type LoadingStrategyType = `${LoadingStrategy}`;
